import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
//import { rotatePlugin } from '@react-pdf-viewer/rotate';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faRedo } from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../apiUrlConstant";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;



function ViewLeasePdfReader({ url, pageNumber }) {

  const [rotation, setRotation] = useState(0);

  const handleRotate = () => {
    setRotation((rotation + 90) % 360);
  };

  const [numPages, setNumPages] = useState(null);
  const [pageNumberView, setPageNumber] = useState(pageNumber);
  //const rotatePluginInstance = rotatePlugin();
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    if (pageNumberView < numPages) {
      setPageNumber(pageNumberView);
    }
  }
  function changePage(offset) {
    console.log(Number(pageNumberView) + offset);
    setPageNumber((pageNumberView) => Number(pageNumberView) + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  // const onUserManualClick = () => {
  //   const fileURL = apiUrl.apiUrl.url + "/lease-report/download-user-manual";
  //   let ele = document.createElement("a");
  //   ele.href = fileURL;
  //   ele.target = "_blank";
  //   ele.click();
  // }
  return (
    <div className="pdfContainer">
      {/* <Document file="somefile.pdf" onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
      <p>
        Page {pageNumber} of {numPages}
      </p> */}
      <div className="button_group d-flex align-items-center gap-3 justify-content-end">
        <button onClick={handleRotate} className="reset_button">
          {/* <FontAwesomeIcon icon={faRedo} /> Rotate */}
          Rotate
        </button>
        {/* <button onClick={onUserManualClick} className="update_button">
          Download
        </button> */}
      </div>

      <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
        {/* <Page pageNumber={Number(pageNumberView)} /> */}
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} rotate={rotation} />
        ))}
      </Document>
      <p>
        Page {pageNumberView} of {numPages}
      </p>
      <button
        type="button"
        disabled={pageNumberView <= 1}
        onClick={previousPage}
      >
        Previous
      </button>
      <button
        type="button"
        disabled={pageNumberView >= numPages}
        onClick={nextPage}
      >
        Next
      </button>
    </div>
  );
}
export { ViewLeasePdfReader };
